const { REACT_APP_BASE_URL } = process.env;

// Log the base URL to verify it's set correctly
console.log("🌐 REACT_APP_BASE_URL:", REACT_APP_BASE_URL);
if (!REACT_APP_BASE_URL) {
  console.warn("⚠️  WARNING: REACT_APP_BASE_URL is not set! API calls will fail!");
  console.warn("   Create a .env file in restaurant-menu directory with:");
  console.warn("   REACT_APP_BASE_URL=https://77.37.51.25 (must be HTTPS)");
}

export const SIGNIN_URL = `${REACT_APP_BASE_URL}/auth/signin`;
export const VALIDATE_TOKEN_URL = `${REACT_APP_BASE_URL}/auth/validateToken`;

export const CUSTOMER_REGISTER_URL = `${REACT_APP_BASE_URL}/auth/customer/register`;
export const CUSTOMER_SIGNIN_URL = `${REACT_APP_BASE_URL}/auth/customer/signin`;
export const CUSTOMER_ME_URL = `${REACT_APP_BASE_URL}/auth/customer/me`;
export const CUSTOMER_ORDERS_URL = `${REACT_APP_BASE_URL}/auth/customer/orders`;
export const CUSTOMER_ADDRESSES_URL = `${REACT_APP_BASE_URL}/auth/customer/addresses`;
export const CUSTOMER_ADDRESS_URL = (id) =>
  `${REACT_APP_BASE_URL}/auth/customer/addresses/${id}`;
export const CUSTOMER_WISHLIST_URL = `${REACT_APP_BASE_URL}/auth/customer/wishlist`;
export const CUSTOMER_WISHLIST_PRODUCT_URL = (productId) =>
  `${REACT_APP_BASE_URL}/auth/customer/wishlist/${productId}`;

export const CUSTOMERS_REGISTERED_URL = `${REACT_APP_BASE_URL}/customers/registered`;
export const CUSTOMERS_REGISTERED_ORDERS_URL = (customerUserId) =>
  `${REACT_APP_BASE_URL}/customers/registered/${customerUserId}/orders`;

export const ADD_PRODUCT_URL = `${REACT_APP_BASE_URL}/products`;
export const GET_PRODUCT_URL = (id) =>
  `${REACT_APP_BASE_URL}/products?restaurantId=${id}`;
export const GET_ONEPRODUCT_URL = (id) =>
  `${REACT_APP_BASE_URL}/products/${id}`;
export const LOG_PRODUCT_URL = (id) =>
  `${REACT_APP_BASE_URL}/products/logs/${id}`;
export const EDIT_PRODUCT_URL = (id) => `${REACT_APP_BASE_URL}/products/${id}`;
export const DELETE_PRODUCT_URL = (id) =>
  `${REACT_APP_BASE_URL}/products/${id}`;

  export const GET_PRODUCTS_URL = (categoryId, page, menuMode) =>
  `${REACT_APP_BASE_URL}/products?categoryId=${categoryId}&page=${page}${menuMode ? `&menuMode=${menuMode}` : ''}`;

export const GET_PRODUCTS_BY_RESTAURANT_URL = (restaurantId, page, menuMode) =>
  `${REACT_APP_BASE_URL}/products?restaurantId=${restaurantId}&page=${page}${menuMode ? `&menuMode=${menuMode}` : ''}`;

export const GET_FEATURED_PRODUCTS_URL = (restaurantId, menuMode) =>
  `${REACT_APP_BASE_URL}/products/featured?restaurantId=${restaurantId}${menuMode ? `&menuMode=${menuMode}` : ''}`;
export const GET_BEST_SELLERS_URL = (restaurantId, menuMode) =>
  `${REACT_APP_BASE_URL}/products/bestsellers?restaurantId=${restaurantId}${menuMode ? `&menuMode=${menuMode}` : ''}`;


export const ADD_CATEGORY_URL = `${REACT_APP_BASE_URL}/categories`;
export const GET_CATEGORIES_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/categories?restaurantId=${restaurantId}`;
export const EDIT_CATEGORY_URL = (id) =>
  `${REACT_APP_BASE_URL}/categories/${id}`;
export const DELETE_CATEGORY_URL = (id) =>
  `${REACT_APP_BASE_URL}/categories/${id}`;
export const LOG_CATEGORY_URL = (id) =>
  `${REACT_APP_BASE_URL}/categories/logs/${id}`;


export const ADD_RESTAURANT_URL = `${REACT_APP_BASE_URL}/restaurants`;
export const ADD_ORDER_URL = `${REACT_APP_BASE_URL}/restaurants/order`;
export const ADD_RESTAURANT_COVER_URL = `${REACT_APP_BASE_URL}/restaurants/addcover`;
export const EDIT_RESTAURANT_COVER_URL = `${REACT_APP_BASE_URL}/restaurants/editcover`;
export const ADD_HOMEPAGE_COVER_URL = `${REACT_APP_BASE_URL}/restaurants/addhomepagecover`;
export const EDIT_HOMEPAGE_COVER_URL = `${REACT_APP_BASE_URL}/restaurants/edithomepagecover`;


export const GET_RESTAURANTS_URL = `${REACT_APP_BASE_URL}/restaurants`;
export const GET_RESTAURANT_URL = (restaurantname) =>
  `${REACT_APP_BASE_URL}/restaurants/${restaurantname}`;
export const EDIT_RESTAURANT_URL = (id) =>
  `${REACT_APP_BASE_URL}/restaurants/${id}`;
export const EDIT_OR_ADD_RESTAURANT_LOGO_URL = (id) =>
  `${REACT_APP_BASE_URL}/restaurants/logo/${id}`;
export const DELETE_RESTAURANT_URL = (id) =>
  `${REACT_APP_BASE_URL}/restaurants/${id}`;
export const GET_RESTAURANT_LOGO_URL = (name) =>
  `${REACT_APP_BASE_URL}/restaurants/${name}?onlyLogo=true`;

export const ADD_BRANCH_URL = `${REACT_APP_BASE_URL}/branches`;
export const GET_BRANCHES_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/branches?restaurantId=${restaurantId}`;
export const EDIT_BRANCH_URL = (id) => `${REACT_APP_BASE_URL}/branches/${id}`;
export const DELETE_BRANCH_URL = (id) => `${REACT_APP_BASE_URL}/branches/${id}`;
export const GET_BRANCH_URL = (id) => `${REACT_APP_BASE_URL}/branches/${id}`;

export const ADD_MEDIA_URL = `${REACT_APP_BASE_URL}/media`;
export const GET_MEDIA_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/media?restaurantId=${restaurantId}`;
export const EDIT_MEDIA_URL = (id) => `${REACT_APP_BASE_URL}/media/${id}`;
export const DELETE_MEDIA_URL = (id) => `${REACT_APP_BASE_URL}/media/${id}`;

export const ADD_SLIDER_IMAGE_URL = `${REACT_APP_BASE_URL}/slider-images`;
export const GET_SLIDER_IMAGES_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/slider-images/${restaurantId}`;
export const EDIT_SLIDER_IMAGE_URL = (id) => `${REACT_APP_BASE_URL}/slider-images/${id}`;
export const DELETE_SLIDER_IMAGE_URL = (id) => `${REACT_APP_BASE_URL}/slider-images/${id}`;

export const GET_BADGES_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/badges/${restaurantId}`;
export const ADD_BADGE_URL = `${REACT_APP_BASE_URL}/badges`;
export const EDIT_BADGE_URL = (id) => `${REACT_APP_BASE_URL}/badges/${id}`;
export const DELETE_BADGE_URL = (id) => `${REACT_APP_BASE_URL}/badges/${id}`;

export const GET_VALUE_CARDS_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/value-cards/${restaurantId}`;
export const ADD_VALUE_CARD_URL = `${REACT_APP_BASE_URL}/value-cards`;
export const EDIT_VALUE_CARD_URL = (id) => `${REACT_APP_BASE_URL}/value-cards/${id}`;
export const UPDATE_VALUE_CARDS_SECTION_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/value-cards/section/${restaurantId}`;
export const DELETE_VALUE_CARD_URL = (id) => `${REACT_APP_BASE_URL}/value-cards/${id}`;

export const GET_ABOUT_US_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/about-us/${restaurantId}`;
export const UPDATE_ABOUT_US_SECTION_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/about-us/section/${restaurantId}`;
export const ADD_ABOUT_US_VALUE_URL = `${REACT_APP_BASE_URL}/about-us/values`;
export const EDIT_ABOUT_US_VALUE_URL = (id) =>
  `${REACT_APP_BASE_URL}/about-us/values/${id}`;
export const DELETE_ABOUT_US_VALUE_URL = (id) =>
  `${REACT_APP_BASE_URL}/about-us/values/${id}`;

export const GET_WORKING_HOURS_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/working-hours?restaurantId=${restaurantId}`;
export const ADD_WORKING_HOURS_URL = `${REACT_APP_BASE_URL}/working-hours`;
export const EDIT_WORKING_HOURS_URL = (id) =>
  `${REACT_APP_BASE_URL}/working-hours/${id}`;
export const DELETE_WORKING_HOURS_URL = (id) =>
  `${REACT_APP_BASE_URL}/working-hours/${id}`;

export const GET_STATS_SECTION_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/stats-section/${restaurantId}`;
export const UPDATE_STATS_SECTION_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/stats-section/${restaurantId}`;
export const ADD_STAT_ITEM_URL = `${REACT_APP_BASE_URL}/stats-section/items`;
export const EDIT_STAT_ITEM_URL = (id) =>
  `${REACT_APP_BASE_URL}/stats-section/items/${id}`;
export const DELETE_STAT_ITEM_URL = (id) =>
  `${REACT_APP_BASE_URL}/stats-section/items/${id}`;

export const THREADS_ADMIN_URL = `${REACT_APP_BASE_URL}/threads/admin`;
export const THREADS_ADMIN_STATS_URL = `${REACT_APP_BASE_URL}/threads/admin/stats`;
export const THREAD_ADMIN_URL = (id) => `${REACT_APP_BASE_URL}/threads/admin/${id}`;
export const THREAD_ADMIN_REPLY_URL = (id) =>
  `${REACT_APP_BASE_URL}/threads/admin/${id}/reply`;
export const THREAD_ADMIN_STATUS_URL = (id) =>
  `${REACT_APP_BASE_URL}/threads/admin/${id}/status`;
export const THREADS_PUBLIC_URL = `${REACT_APP_BASE_URL}/threads`;

export const GET_FEEDBACKS_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/feedback/${restaurantId}`;

// Clinic: Staff Members
export const GET_STAFF_URL = (rid) => `${REACT_APP_BASE_URL}/staff-members/${rid}`;
export const ADD_STAFF_URL = `${REACT_APP_BASE_URL}/staff-members`;
export const EDIT_STAFF_URL = (id) => `${REACT_APP_BASE_URL}/staff-members/${id}`;
export const DELETE_STAFF_URL = (id) => `${REACT_APP_BASE_URL}/staff-members/${id}`;
// Clinic: FAQs
export const GET_FAQS_URL = (rid) => `${REACT_APP_BASE_URL}/faqs/${rid}`;
export const ADD_FAQ_URL = `${REACT_APP_BASE_URL}/faqs`;
export const EDIT_FAQ_URL = (id) => `${REACT_APP_BASE_URL}/faqs/${id}`;
export const DELETE_FAQ_URL = (id) => `${REACT_APP_BASE_URL}/faqs/${id}`;
// Clinic: Packages
export const GET_PACKAGES_URL = (rid) => `${REACT_APP_BASE_URL}/packages/${rid}`;
export const ADD_PACKAGE_URL = `${REACT_APP_BASE_URL}/packages`;
export const EDIT_PACKAGE_URL = (id) => `${REACT_APP_BASE_URL}/packages/${id}`;
export const DELETE_PACKAGE_URL = (id) => `${REACT_APP_BASE_URL}/packages/${id}`;
// Clinic: Gallery
export const GET_GALLERY_URL = (rid) => `${REACT_APP_BASE_URL}/gallery/${rid}`;
export const ADD_GALLERY_URL = `${REACT_APP_BASE_URL}/gallery`;
export const EDIT_GALLERY_URL = (id) => `${REACT_APP_BASE_URL}/gallery/${id}`;
export const DELETE_GALLERY_URL = (id) => `${REACT_APP_BASE_URL}/gallery/${id}`;

/** All-time visit range for dashboard totals (restaurant menu loads). */
export const GET_RESTAURANT_VISIT_COUNT_URL = (restaurantId, startDate, toDate) =>
  `${REACT_APP_BASE_URL}/restaurants/logs/get-visit-count?restaurant_id=${encodeURIComponent(
    restaurantId
  )}&startDate=${encodeURIComponent(startDate)}&toDate=${encodeURIComponent(toDate)}`;

export const GET_RESTAURANT_TOP_PRODUCT_VISITS_URL = (restaurantId, startDate, toDate, limit = 12) =>
  `${REACT_APP_BASE_URL}/restaurants/logs/top-product-visits?restaurant_id=${encodeURIComponent(
    restaurantId
  )}&startDate=${encodeURIComponent(startDate)}&toDate=${encodeURIComponent(
    toDate
  )}&limit=${encodeURIComponent(limit)}`;

export const GET_RESTAURANT_TOP_CATEGORY_VISITS_URL = (restaurantId, startDate, toDate, limit = 12) =>
  `${REACT_APP_BASE_URL}/restaurants/logs/top-category-visits?restaurant_id=${encodeURIComponent(
    restaurantId
  )}&startDate=${encodeURIComponent(startDate)}&toDate=${encodeURIComponent(
    toDate
  )}&limit=${encodeURIComponent(limit)}`;

export const GET_RESTAURANT_VISIT_DAILY_SERIES_URL = (restaurantId, startDate, toDate) =>
  `${REACT_APP_BASE_URL}/restaurants/logs/visit-daily?restaurant_id=${encodeURIComponent(
    restaurantId
  )}&startDate=${encodeURIComponent(startDate)}&toDate=${encodeURIComponent(toDate)}`;

export const GET_ORDERS_BY_RESTAURANT_URL = (restaurantId) =>
  `${REACT_APP_BASE_URL}/orders/restaurant/${restaurantId}`;

export const GET_THREADS_ADMIN_PAGE_URL = (page = 1, pageSize = 1) =>
  `${REACT_APP_BASE_URL}/threads/admin?page=${page}&pageSize=${pageSize}`;